import { DatabaseModel, ModelJson } from './database-model';

export enum GroupEventType {
    GROUP_START_TOUR = 'GROUP_START_TOUR',
    GROUP_MEMBER_JOIN = 'GROUP_MEMBER_JOIN',
    GROUP_MEMBER_LEAVE = 'GROUP_MEMBER_LEAVE',
    GROUP_UNLOCK_MOTE = 'GROUP_UNLOCK_MOTE',
    GROUP_PLAYBACK_REQUEST = 'GROUP_PLAYBACK_REQUEST',
    GROUP_QUIZ_REQUEST = 'GROUP_QUIZ_REQUEST'
}

export class GroupEvent extends DatabaseModel {
    /** Key for the GroupEvent */
    public key: string;
    /** The type of the `GroupEvent` */
    public type: GroupEventType;
    /** Key for the `Mote` related to this event */
    public moteKey: string;
    /** Key for the `User` who caused this event */
    public userKey: string;
    /** Key for the media associated with this event, if any */
    public mediaKey: string;
    /** Key for the target group member of this event, if any */
    public memberKey: string;
    /** Timestamp (in ms) for the creation of the event */
    public createdOn: number;
    /** Preview key in order to give other group members access to an unpublished tour */
    public previewKey: string;


    /**
     * Instantiate a `GroupEvent` and call `DatabaseModel` super constructor
     */
    constructor(json: any = null, key: string = '') {
        super();
        this.key = key ? key : DatabaseModel.genKey();
        if(json) this.fromJson(json);
    }

    /**
     * Populate member variables with JSON data (deserialize)
     */
    public fromJson(json: ModelJson): GroupEvent {
        Object.assign(this, json);
        return this;
    }

    /**
     * Serialize model to JSON
     */
    public toJson(): ModelJson {
        let json = Object.assign({}, this);
        return json;
    }
}
